import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import './LegalApp.css';
import Navbar from './Navbar';
import Footer from './Footer';

const UploadResponse = ({ API_URL }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const responseGivenBy = location.state?.responseGivenBy ?? null;
  const primaryFIR = location.state?.primaryFIR ?? null;
  const secondaryFIR = location.state?.secondaryFIR ?? null;
  // const id = location.state?.id ?? null;
  const [language, setLanguage] = useState('English');
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isTyping, setIsTyping] = useState(true);
  const [responseText, setResponseText] = useState('Date of Examination:\nName:\n\nInterrogation Response/Statement:\n');
  const [showOtherLanguagePopup, setShowOtherLanguagePopup] = useState(false);

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setErrorMessage(null);
    if (!isTyping && !selectedFile) {
      //alert('Please select the document to proceed.'); 
      setErrorMessage("Please select the response PDF to proceed.");
      return;
    };

    if (isTyping && (responseText.trim() === '' || responseText === 'Date of Examination:\nName:\n\nInterrogation Response/Statement:\n')) {
      //alert('Please type the FIR text to proceed.');
      setErrorMessage("Please put the interrogation response to proceed.");
      return;
    }

    setIsLoading(true);
    var jwt = localStorage.getItem('jwtToken');

    const formData = new FormData();
    formData.append('primaryFIR', primaryFIR);
    formData.append('secondaryFIR', secondaryFIR);
    formData.append('responseGivenBy', responseGivenBy);
    formData.append('language', language);

    if (isTyping) {
      formData.append('responseText', responseText);
    } else {
      formData.append('file', selectedFile);
    }

    try {
      var uri = '/fir/ir-pdf';
      if (isTyping) {
        uri = '/fir/ir';
      }

      const response = await axios.post(API_URL + uri, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${jwt}`,
        },
      });
      //console.log('API Response Status:', response.status);
      //console.log('API Response:', response.data);

      if (isTyping) {
        navigate('/fir', { state: { API_URL: API_URL, data: response.data } });
      } else {
        navigate('/response/text', { state: { API_URL: API_URL, data: response.data, } });
      }
    } catch (error) {
      const defaultErrorMessage = 'An error occurred while submitting the form. Please try again later.';
      if (error.response?.status === 401) {
        setErrorMessage('This voucher code is invalid. For assistance or to request additional vouchers, please email us at contact@legalapp.in.');
      } else {
        setErrorMessage(error.response?.data?.message || error.message || defaultErrorMessage);
      }
      console.error('Error submitting the form:', error);
    } finally {
      setIsLoading(false);
      localStorage.removeItem('firList');
    }
  };

  const handleLanguageChange = (event) => {
    if (event.target.value === 'Other') {
      setShowOtherLanguagePopup(true);
    } else {
      setLanguage(event.target.value);
      setShowOtherLanguagePopup(false);
    }
  };

  const handleLanguageChangePopup = (event) => {
    setShowOtherLanguagePopup(false);
  }

  const handleTyping = () => {
    setIsTyping(!isTyping);
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div>
      <Navbar />

      <div className="form-container" style={{ marginTop: '200px' }}>
        <div style={{ alignContent: 'center', textAlign: 'center' }}>
          <h2>Analyse Interrogation Response</h2>
        </div>
        <br></br>
        <form className="responsive-form" onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="user">Response Given By</label>
            {/* <select id="responseGivenBy" name="responseGivenBy" className="upload-select" value={responseGivenBy} disabled>
              <option>
                Complainant
              </option>
              <option>
                Accused
              </option>
            </select> */}
            <input
              type="text"
              id="responseGivenBy"
              name="responseGivenBy"
              className="upload-select"
              value={responseGivenBy}
              readOnly
            />
          </div>

          <div className="form-group">
            <label htmlFor="document-type">Response Language</label>
            <select id="document-type" name="document-type" className="upload-select" onChange={handleLanguageChange} value={language}>
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
              <option value="Gujarati">Gujarati</option>
              <option value="Marathi">Marathi</option>
              <option value="Bengali">Bengali</option>
              <option value="Telugu">Telugu</option>
              <option value="Tamil">Tamil</option>
              <option value="Kannada">Kannada</option>
              <option value="Malayalam">Malayalam</option>
              <option value="Punjabi">Punjabi</option>
              <option value="Other">Other Languages</option>
            </select>
          </div>

          {/* <div className="form-group">
            <label htmlFor="document">Upload or Type Response</label>
            <div className="file-input-container">
              <input
                type="file"
                id="document"
                name="document"
                accept=".pdf"
                onChange={handleFileChange}
                className="file-input"
                ref={fileInputRef}
              />
              <input
                type="text"
                value={selectedFile ? selectedFile.name : ''}
                placeholder="Select PDF"
                readOnly
                className="file-name"
                style={{ fontSize: "12px", }}
              />
              <button
                type="button"
                onClick={() => {
                  setIsTyping(false);
                  document.getElementById('document').click()
                }}
                className="browse-button"
                style={{
                  width: "75px",
                }}
                disabled={isLoading || language === 'Other'}
              >
                Browse
              </button>
              <button
                type="button"
                onClick={handleTyping}
                className="browse-button"
                style={{
                  width: "75px",
                  backgroundColor: isTyping ? "#4caf50" : "#e0e0e0", // green when active, grey when not
                  color: isTyping ? "white" : "black",
                  border: "1px solid #ccc"
                }}
                disabled={isLoading || language === 'Other'}
              >
                Type
              </button>
            </div>
          </div> */}
          <br></br>
          {isTyping && (
            <div className="form-group">
              <label htmlFor="document">Interrogation Response / Statement</label>
              <textarea
                value={responseText}
                onChange={(e) => setResponseText(e.target.value)}
                style={{
                  width: '97%',
                  height: '300px',
                  marginTop: '10px',
                  fontSize: '16px',
                  lineHeight: '1.5',
                  resize: 'vertical',
                }}
              />
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <button
              type="submit"
              className="submit-button"
              style={{ fontWeight: "bold" }}
              disabled={isLoading || language === 'Other' || (!isTyping && !selectedFile) || (isTyping && responseText.trim() === '')}
              hidden={errorMessage}>
              {isLoading ? <div className="spinner"></div> : 'Submit'}
            </button>
            <div hidden={!isLoading} style={{ marginTop: '10px', alignContent: 'center', textAlign: 'center' }}>
              <p style={{ fontSize: '14px' }} hidden={!isLoading}>
                <strong>
                  Please wait. AI Agent is analyzing the interrogation response - this may take about a minute depending on the complexity of the complaint.
                </strong>
              </p>
            </div>
          </div>
        </form>

        {errorMessage && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Error</h2>
              <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>
                <strong>{errorMessage}</strong>
              </div>
              <button
                className="error-ok-button"
                onClick={() => setErrorMessage(null)}
                style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
              >
                OK
              </button>
            </div>
          </div>
        )}

        {showOtherLanguagePopup && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>Support for more languages coming soon!</h3>
              <p>In the meantime, please translate the statement into English using tools like <a href="https://chat.openai.com/" target="_blank" rel="noopener noreferrer">ChatGPT</a> and <a href="https://openpdf.com/lp/translate-pdf.html" target="_blank" rel="noopener noreferrer">OpenPDF</a> and upload the translated FIR as a PDF.</p>
              <p><strong>For assistance, please email us at contact@legalapp.in.</strong></p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={handleLanguageChangePopup}
                >Close</button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default UploadResponse;
